import constants from "./constants";

export default {
  appTitle: process.env.VUE_APP_TITLE,
  appHelpEmailSubject: process.env.VUE_APP_HELP_EMAIL_SUBJECT,
  appPublicUrl: process.env.VUE_APP_PUBLIC_URL,
  userAccount: null,
  userIsLoggedIn: false,
  userLoginFailed: false,
  logoImagePath: "nvelogo.svg",
  pointStyles: constants.DRAW_SYMBOLS_POINTS,
  lineStyles: constants.DRAW_SYMBOLS_LINES,
  polygonStyles: constants.DRAW_SYMBOLS_POLYGONS,
  favourites: [],
  showAppDrawer: false,
  showSideMenu: true,
  showMiniDrawer: true,
  showHovedforklaring: false,
  mainThemeID: null,
  currentMapScale: 0,
  activeExclusiveToolName: "layers",
  showInfoMenu: false,
  selectedTheme: {},
  showImageGallery: false,
  explorerVisible: false,
  sidebarHasOpened: false,
  coordinatesVisible: false,
  measureActive: false,
  sceneViewLoaded: false,
  drawingActive: false,
  selectedPrintWidth: 1050,
  selectedPrintHeight: 605,
  selectedPageFormat: {
    title: "A4 Liggende",
    id: "a4-landscape",
    width: 1050,
    height: 605,
  },
  selectedPrintScale: {
    level: 1,
    resolution: 78271.51696399994,
    scale: 2.95828763795777e8,
  },
  bottomTabsHeight: 0,
  is3d: false,
  showTabs: false,
  mapHeight: 100,
  visibleTools: [],
  tools: {
    layers: {
      icon: "mdi-layers",
      title: "Kartlag",
      active: true,
      exclusive: true,
      isMapTool: false,
      showInTopToolbar: true,
      useSidebarOnMobile: true,
    },
    search: {
      icon: "mdi-magnify",
      title: "Søk",
      active: false,
      exclusive: true,
      isMapTool: false,
      showInTopToolbar: true,
      useSidebarOnMobile: true,
    },
    drawing: {
      icon: "mdi-pencil",
      title: "Tegn i kartet",
      active: false,
      exclusive: false,
      isMapTool: true,
      showInTopToolbar: true,
      useSidebarOnMobile: false,
    },
    print: {
      icon: "mdi-printer",
      title: "Skriv ut",
      active: false,
      exclusive: true,
      isMapTool: false,
      showInTopToolbar: true,
      useSidebarOnMobile: false,
    },
    measure: {
      icon: "mdi-ruler",
      title: "Måleverktøy",
      active: false,
      exclusive: false,
      isMapTool: true,
      showInTopToolbar: true,
      useSidebarOnMobile: false,
    },
    bookmarks: {
      icon: "mdi-bookmark-outline",
      title: "Bokmerker",
      active: false,
      exclusive: true,
      isMapTool: false,
      showInTopToolbar: false,
      useSidebarOnMobile: true,
    },
    share: {
      icon: "mdi-share-variant",
      title: "Del kartet",
      active: false,
      exclusive: false,
      isMapTool: true,
      showInTopToolbar: false,
      useSidebarOnMobile: false,
    },
    coordinates: {
      text: "x/y",
      title: "Vis koordinater",
      active: false,
      hideInMenus: true,
      exclusive: false,
      isMapTool: true,
      showInTopToolbar: false,
      useSidebarOnMobile: false,
    },
    help: {
      icon: "mdi-help-circle-outline",
      title: "Tips og triks",
      active: false,
      exclusive: true,
      isMapTool: false,
      showInTopToolbar: false,
      useSidebarOnMobile: true,
    },
  },
  // useDarkMode: false,
  guideIsRunning: false,
  settingsDialogActive: false,
  hideWelcomeDialog: false,
  hide3dNavigationHelpDialog: false,
  mapLoaded: false,
  tabsAreOpen: false,
  graphicsLayers: [],
  bottomSheets: [],
  elevationProfiles: [],
  imageGalleryItems: [],
  defaultExtent: {
    spatialReference: {
      wkid: 25833,
    },
    xmin: -403198.0839137276,
    ymin: 6252470.949794861,
    xmax: 1311813.3461091325,
    ymax: 8047407.873002041,
  },
  extent: {
    spatialReference: {
      wkid: 25833,
    },
    xmin: -403198.0839137276,
    ymin: 6252470.949794861,
    xmax: 1311813.3461091325,
    ymax: 8047407.873002041,
  },
  theMap: null,
  theMapView: null,
  showPopupsOnClick: true,
  selectedExtent: null,
  showCatalogue: false,
  showPredefinedBookmarks: false,
  zoom: null,
  selectedBasemap: null,
  layerMetadata: [],
  layerDefinitionExpressions: {},
  selectedMapProfile: null,
  addedProfiles: [],
  mapProfiles: [],
  lastVisitedMaps: [],
  layerInfos: [],
  externalLinks: [
    {
      title: "NVE forsiden",
      url: "https://www.nve.no",
    },
    {
      title: "NVE Atlas",
      url: "https://atlas.nve.no/",
    },
    {
      title: "SeNorge",
      url: "https://www.senorge.no/",
    },
    {
      title: "Geonorge",
      url: "https://www.geonorge.no/",
    },
    {
      title: "Norgeskart",
      url: "http://www.norgeskart.no/#",
    },
    {
      title: "Norge i bilder",
      url: "https://www.norgeibilder.no/",
    },
  ],
  profileCategories: [
    { title: "Alle", icon: "mdi-expand-all-outline" },
    { title: "Favoritter", icon: "mdi-star-outline" },
    { title: "Aktsomhet", icon: "mdi-sign-caution" },
    { title: "Energi", icon: "mdi-flash-outline" },
    { title: "Fare", icon: "mdi-hazard-lights" },
    { title: "Vann", icon: "mdi-waves" },
    { title: "Vern og sikring", icon: "mdi-shield-outline" },
    { title: "Ymse", icon: "mdi-dots-horizontal-circle-outline" },
    { title: "Interne kart", icon: "mdi-lock-outline", internal: true },
    { title: "Satellitt", icon: "mdi-satellite-variant" },
    { title: "Mine kart", icon: "mdi-account" },
  ],

  basemaps: [
    {
      id: "topo4graatone",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheGraatone/MapServer",
      },
      title: "Gråtone",
      thumbnailUrl: "/img/graatone.jpg",
      active: true,
      type: "mapImageLayer",
    },
    {
      id: "ortofoto",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheBilder/MapServer",
      },
      subDomains: [],
      title: "Bilder",
      thumbnailUrl: "/img/bilder.jpg",
      active: false,
      type: "mapImageLayer",
    },
    {
      id: "topo",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheBasis/MapServer",
      },
      subDomains: [],
      title: "Basis",
      thumbnailUrl: "/img/basis.jpg",
      active: false,
      type: "mapImageLayer",
    },
    {
      id: "landskap",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheLandskap/MapServer",
      },
      subDomains: [],
      title: "Landskap",
      thumbnailUrl: "/img/landskap.jpg",
      active: false,
      type: "mapImageLayer",
    },
    {
      id: "svalbard",
      options: {
        url:
          "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_25833/MapServer",
      },
      subDomains: [],
      title: "Svalbard",
      thumbnailUrl: "/img/svalbard.jpg",
      active: false,
      type: "mapImageLayer",
    },
    {
      id: "vektorgraatone",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatone/VectorTileServer",
      },
      subDomains: [],
      title: "Grå vektor",
      thumbnailUrl: "/img/graatone.jpg",
      active: false,
      type: "vector",
    },
    {
      id: "vektorterreng",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng/VectorTileServer",
      },
      subDomains: [],
      title: "Terreng vektor",
      thumbnailUrl: "/img/landskap.jpg",
      active: false,
      type: "vector",
    },
    {
      id: "vektorbasis",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasis/VectorTileServer",
      },
      subDomains: [],
      title: "Basis vektor",
      thumbnailUrl: "/img/basis.jpg",
      active: false,
      type: "vector",
    },
    {
      id: "forenkletvektorgraatone",
      title: "Grå forenklet",
      thumbnailUrl: "/img/graatone.jpg",
      active: false,
      type: "vector",
      options: {
        url: "/basemaps/basemap_style_v1.json",
      },
    },
    {
      id: "skyggerelieffdtm",
      useProxy: true,
      options: {
        url:
          "https://hoydedata.no/arcgis/rest/services/NHM_DTM_25833/ImageServer",
        rasterFunction: "skyggerelieff",
        // sublayers: [
        //   {
        //     name: "las_dtm_skyggerelieff_somlos:skyggerelieff_40grader",
        //     legendUrl:
        //       "https://wms.geonorge.no/skwms1/wms.hoyde-dtm_somlos_skyggerelieff?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=las_dtm_skyggerelieff_somlos:skyggerelieff_40grader"
        //   }
        // ]
      },
      title: "Skyggerelieff",
      thumbnailUrl: "/img/skygge.jpg",
      active: false,
      type: "imagerylayer",
    },
    {
      id: "graatonetransparent",
      options: {
        url:
          "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheGraatone/MapServer",
        opacity: 0.75,
      },
      title: "Transparent",
      thumbnailUrl: "/img/graatone.jpg",
      active: true,
      type: "mapImageLayer",
    },
  ],
  profiles: null,
  currentlyOpenedProject: null,
  showLayerInfoCard: true,
  snack: "",
  snackLoading: false,
  snackTimeout: 6000,
  copiedGeometry: null,
  buildingsLayerAdded: false,
  popupVisible: false,
  currentOrientation: 0,
  saveIsEnabled: true,
  geometryOperations: [
    {
      name: "Buffer",
      function: "buffer",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometri",
          type: "geometry",
          multiple: true,
          value: null,
          geometryType: "all",
        },
        {
          id: "distance",
          name: "Avstand",
          value: 0,
          description: "Avstand",
          type: "number",
        },
        {
          id: "unit",
          name: "Enhet",
          description: "Velg enhet for avstand",
          type: "select",
          value: null,
          items: [
            {
              text: "Meter",
              value: "meters",
            },
            {
              text: "Kilometer",
              value: "kilometers",
            },
          ],
        },
      ],
    },
    {
      name: "Speilvend horisontalt",
      function: "flipHorizontal",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometri",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Speilvend vertikalt",
      function: "flipVertical",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometri",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Simplifiser",
      function: "simplify",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometri",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Union",
      function: "union",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometriene som skal slås sammen",
          type: "geometry",
          multiple: true,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Differanse",
      function: "difference",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg hovedgeometri",
          type: "geometry",
          multiple: true,
          value: null,
          geometryType: "all",
        },
        {
          id: "subtractor",
          name: "Geometri som trekkes fra",
          description: "Velg geometri som skal trekkes fra",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Kutt",
      function: "cut",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Geometrien som skal kuttes",
          description: "Velg geometrien som skal kuttes",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
        {
          id: "subtractor",
          name: "Polylinjen som skal brukes som kutter",
          description: "Velg polylinjen som skal brukes som kutter",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "polyline",
        },
      ],
    },
    {
      name: "Symmetrisk differanse",
      function: "symmetricDifference",
      description: "Bla bla",
      parameters: [
        {
          id: "leftGeometry",
          name: "Input geometri",
          description: "Velg venstre geometri",
          type: "geometry",
          multiple: true,
          value: null,
          geometryType: "all",
        },
        {
          id: "rightGeometry",
          name: "Høyre geometri",
          description: "Velg høyre geometri",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
    {
      name: "Snitte",
      function: "intersect",
      description: "Bla bla",
      parameters: [
        {
          id: "geometry",
          name: "Input geometri",
          description: "Velg geometri",
          type: "geometry",
          multiple: true,
          value: null,
          geometryType: "all",
        },
        {
          id: "intersector",
          name: "Snitte",
          description: "Velg snittegeometri",
          type: "geometry",
          multiple: false,
          value: null,
          geometryType: "all",
        },
      ],
    },
  ],
  settingsMetadata: [
    {
      name: "theme",
      title: "Utseende",
      settings: [
        {
          id: "useDarkMode",
          name: "Fargemodus",
          type: "select",
          options: [
            {
              name: "Lys",
              value: false,
            },
            {
              name: "Mørk",
              value: true,
            },
          ],
        },
      ],
    },
    {
      name: "mapSettings",
      title: "Kart",
      settings: [
        {
          id: "sceneViewQualityProfile",
          type: "select",
          options: [
            {
              name: "Lav kvalitet",
              value: "low",
            },
            {
              name: "Medium kvalitet",
              value: "medium",
            },
            {
              name: "Høy kvalitet",
              value: "high",
            },
          ],
          name:
            "3D visning: Kvalitetsprofil (denne innstillingen påvirker ytelsen)",
          description: "bla bla",
        },
        {
          id: "identifyResultMaxAllowableOffsetInMeters",
          type: "select",
          name:
            "Maks tillatte avvik mellom seleksjonsgeometri og originalgeometri",
          description: "bla bla",
          options: [
            {
              name: "1 meter (kan føre til veldig lav ytelse i noen temaer)",
              value: 1,
            },
            {
              name: "5 meter (kan føre til lav ytelse i noen temaer)",
              value: 5,
            },
            {
              name: "10 meter (merk: kan påvirke ytelse i noen temaer)",
              value: 10,
            },
            {
              name: "15 meter (anbefalt)",
              value: 15,
            },
            {
              name: "20 meter",
              value: 20,
            },
            {
              name: "25 meter",
              value: 25,
            },
          ],
        },
      ],
    },
    {
      name: "drawingSettings",
      title: "Tegning",
      settings: [
        {
          id: "useZvaluesWhenDrawingIn3D",
          type: "select",
          name: "Bruk av høyde når du tegner i 3D",
          description: "bla bla",
          options: [
            {
              name:
                "Ikke bruk høyde (punkt, linje, flate festes til bakkenivå)",
              value: false,
            },
            {
              name: "Bruk høyde (høyden til punkt, linje, flate kan redigeres)",
              value: true,
            },
          ],
        },
        {
          id: "drawingCreationMode",
          type: "select",
          name: "Oppførsel etter at bruker har tegnet inn et element",
          description: "bla bla",
          options: [
            {
              name: "Tegneoperasjon avsluttes mellom hver inntegning",
              value: "single",
            },
            {
              name: "Bruker kan tegne inn flere elementer etter hverandre",
              value: "continuous",
            },
            {
              name: "Inntegnet element selekteres for redigering",
              value: "update",
            },
          ],
        },
        {
          id: "drawingInputMode",
          type: "select",
          name: "Modus for registrering av knekkpunkter",
          description: "bla bla",
          options: [
            {
              name: "Knekkpunkter legges til ved klikk",
              value: "click",
            },
            {
              name: "Knekkpunkter legges til ved klikk og dra (frihånd)",
              value: "continuous",
            },
            {
              name: "Hybrid: Knekkpunkter legges til både ved klikk og dra.",
              value: "hybrid",
            },
          ],
        },
      ],
    },
  ],
  userSettings: {
    theme: {
      name: "NVE (standard)",
      definition: {
        primary: process.env.VUE_APP_THEME_PRIMARY_COLOR,
        secondary: "#f5f5f5",
        accent: "#8c9eff",
        error: "#b71c1c",
      },
    },
    sceneViewQualityProfile: "low",
    useZvaluesWhenDrawingIn3D: false,
    drawingInputMode: "click",
    drawingCreationMode: "single",
  },
  defaultUserSettings: {
    theme: {
      name: "NVE (standard)",
      definition: {
        primary: process.env.VUE_APP_THEME_PRIMARY_COLOR,
        secondary: "#f5f5f5",
        accent: "#8c9eff",
        error: "#b71c1c",
      },
    },
    useDarkMode: false,
    drawingInputMode: "click",
    drawingCreationMode: "single",
    sceneViewQualityProfile: "low",
    useZvaluesWhenDrawingIn3D: false,
    identifyResultMaxAllowableOffsetInMeters: 15,
  },
  photoStreamIsActivated: false,
  mapBookmarks: [],
  isConnectedToIntranet: false,
  startupDialog: null,
  layersAreLoading: true,
};
